import { render } from "./AdminLayout.vue?vue&type=template&id=571c87fc&scoped=true"
import script from "./AdminLayout.vue?vue&type=script&lang=js"
export * from "./AdminLayout.vue?vue&type=script&lang=js"

import "./AdminLayout.vue?vue&type=style&index=0&id=571c87fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571c87fc"]])

export default __exports__